import { globalState } from '@/state/globalState';
import { supabase, createSessionBoundSupabaseClient } from '@/services/supabase';
import { getSyncClientBuild, GPS_ADDRESS_FEATURE } from '@/services/sync/SyncCanaryFeatureService';

/** Criação estrutural exige uma decisão online da identidade corrente. */
export const canCreateGpsAddressField = async (companyId: string): Promise<boolean> => {
  const userId = globalState.user.profile.get()?.id;
  const build = getSyncClientBuild();
  const matches = () => globalState.user.isAuthenticated.get() === true
    && globalState.network.isConnected.get() === true
    && !!userId && globalState.user.profile.get()?.id === userId
    && globalState.user.profile.get()?.empresa_id === companyId
    && globalState.user.session.get()?.user?.id === userId;
  if (!matches() || build < 142) return false;
  try {
    const { data: auth, error: authError } = await supabase.auth.getSession();
    if (authError || !auth.session?.access_token || auth.session.user.id !== userId || !matches()) return false;
    const { data, error } = await createSessionBoundSupabaseClient(auth.session.access_token).rpc('app_guincho_feature_enabled_v1', {
      p_empresa_id: companyId, p_feature_key: GPS_ADDRESS_FEATURE, p_client_build: build,
    });
    return !error && data === true && matches();
  } catch { return false; }
};
